import { EReputationStatus } from "src/core/constants/eReputation";
import { AdvancedPersonSearchQuery, DocumentStatus, FolderFileQuery } from "src/core/gql/graphql";

export enum StakeholderRoleEnum {
  legal_representative = "RL",
  direct_beneficiary_owner = "BE",
}

export enum GenderEnum {
  Monsieur = "Monsieur",
  Madame = "Madame",
}

export enum StakeholderType {
  Person = "Person",
  Corporation = "Corporation",
  Entrepreneur = "Entrepreneur",
}

export type MappedStakeholderDocument = {
  code: string;
  name: string;
  uploaded: boolean;
  id?: string | null;
  fileName?: string | null;
  type?: {
    code: string;
    name: string;
  };
  externalDocument?: boolean;
  status?: DocumentStatus;
};

type AdvancedPerson = NonNullable<
  NonNullable<AdvancedPersonSearchQuery["advancedPersonSearch"]>["persons"]
>[number];

export type AdvancedPersonWithEReputationStatus = AdvancedPerson & {
  pepStatus: EReputationStatus;
  sanctionStatus: EReputationStatus;
};

export type MappedStakeholder = {
  id: string;

  type: StakeholderType /** Type de stakeholder */;
  riskLevel?: string /** Niveau de risque */;
  roles: StakeholderRoleEnum[] /** Rôles */;
  isFolderCustomer: boolean /** Est l'entreprise du dossier */;
  isLegalRepresentative: boolean /** Est un représentant légal */;
  isBeneficiaryOwner: boolean /** Est un bénéficiaire effectif */;
  title?: string /** Civilité */;
  firstName?: string /** Prénom */;
  birthName?: string /** Nom de naissance */;
  lastName?: string /** Nom */;
  citizenshipCountryCode?: string /** Nationalité */;
  birthDate?: string /** Date de naissance */;
  residenceCountryCode?: string /** Pays de résidence */;
  birthCountryCode?: string /** Pays de naissance */;
  birthPlace?: string /** Ville de naissance */;
  socialReason?: string /** Raison sociale */;
  documents: MappedStakeholderDocument[];
  pepStatus?: EReputationStatus;
  sanctionStatus?: EReputationStatus;

  missingRequiredFieldCount: number /** Nombre de champs requis manquants */;
  missingDocumentCount: number /** Nombre de documents manquants */;

  duplicateCheckDone: boolean /** Vérification de duplication faite */;

  /** candidats retournés par advancedPersonSearch */
  duplicateCandidates?: AdvancedPersonWithEReputationStatus[];
  duplicateCheckLoading: boolean;

  /** indique que la vérification de duplication a été faite */
  duplicateCheckFetched: boolean;
};

export type FolderFileData = NonNullable<FolderFileQuery["folderFile"]>;
export type FileCustomerFolderData = NonNullable<FolderFileData["fileCustomerFolder"]>;
export type PartialFolderStakeholder = FileCustomerFolderData["stakeholders"][number];
export const QuestionnaireTypeCode = {
  LAB: "lab",
  LAB_PPH: "lab_pph",
};
export const CustomerFolderTypeCode = {
  PPH: "accountant_folder_pph",
  ENTREPRISE: "accountant_folder",
};
export const MessageThreadTopicCode = {
  OTHER: "Other",
};

export const MessageThreadTitle = {
  COMMENTS: "Commentaires",
};

export const FolderFileDocumentCode = {
  MISSION_LETTER: "mission_letter",
};
